import { render, staticRenderFns } from "./CVPreview.vue?vue&type=template&id=38cb56d5&scoped=true"
import script from "./CVPreview.vue?vue&type=script&lang=js"
export * from "./CVPreview.vue?vue&type=script&lang=js"
import style0 from "./CVPreview.vue?vue&type=style&index=0&id=38cb56d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb56d5",
  null
  
)

export default component.exports